var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCabinet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u914D\u7535\u67DC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56DE\\u8DEF\\u6570\\u636E\\u7EDF\\u8BA1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-29.000000, -72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u914D\\u7535\\u67DC",
    transform: "translate(30.500000, 73.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#979797",
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#4A90E2",
    x: 8,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD",
    fill: "#4A90E2",
    x: 10,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 9,
    x2: 12,
    y2: 9,
    id: "\\u8DEF\\u5F84-12",
    stroke: "#979797"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#4A90E2",
    x: 3.5,
    y: 3.5,
    width: 6,
    height: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinet);
export default __webpack_public_path__ + "static/media/cabinet.786264959d7c434e52297e3b7ca3e647.svg";
export { ForwardRef as ReactComponent };